import { useTranslation } from "react-i18next";

const advantages = [
  { titleKey: "seminars.adv.card1.title", descKey: "seminars.adv.card1.desc", icon: "ri-speed-line", stat: "50%" },
  { titleKey: "seminars.adv.card2.title", descKey: "seminars.adv.card2.desc", icon: "ri-leaf-line", stat: "淨零" },
  { titleKey: "seminars.adv.card3.title", descKey: "seminars.adv.card3.desc", icon: "ri-temp-cold-line", stat: "-5°C" },
];

export default function AdvantagesSection() {
  const { t } = useTranslation();

  return (
    <section className="section-padding bg-graphite">
      <div className="container-main">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <span className="tag-label mb-4 inline-block">{t("seminars.adv.label")}</span>
          <h2 className="text-white mb-4">{t("seminars.adv.title")}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {advantages.map((a) => (
            <div
              key={a.titleKey}
              className="relative bg-slate-blue/60 rounded-xl p-7 md:p-8 border border-white/10 transition-all duration-300 hover:bg-slate-blue/80 hover:translate-y-[-4px]"
            >
              <div className="text-champagne font-serif text-4xl md:text-5xl font-bold mb-5">
                {a.stat}
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-champagne/15 mb-4">
                <i className={`${a.icon} text-2xl text-champagne`} />
              </div>
              <h3 className="text-white text-[1.375rem] md:text-[1.625rem] mb-3">{t(a.titleKey)}</h3>
              <p className="text-cream/70 text-base mb-0">{t(a.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}